import { SuggestionData } from 'ckeditor5-premium-features'
import { TrackChangeStatus, TrackedChange } from 'models/changes'
import React, { memo } from 'react'
import { TrackChangeCard as Card } from './card/Card'

interface SuggestionCardWrapperProps {
    suggestion: SuggestionData
    trackChangesData: Record<string, TrackedChange>
    isNotDefaultSuggestionCardFilter?: boolean
    index: number
    suggestionCardFilter?: string
}

/**
 * SuggestionCardWrapper component renders a card for track changes based on the suggestion and its status.
 * It uses memoization to optimize performance and avoid unnecessary re-renders.
 * @param {SuggestionCardWrapperProps} props - The properties for the SuggestionCardWrapper component.
 * @return {JSX.Element | null} The rendered suggestion card or null if not applicable.
 */
export const SuggestionCardWrapper = memo(
    ({
        suggestion,
        trackChangesData,
        isNotDefaultSuggestionCardFilter,
        suggestionCardFilter,
    }: SuggestionCardWrapperProps) => {
        // Simplified status logic for clarity and maintainability
        let status: TrackChangeStatus
        if (
            !isNotDefaultSuggestionCardFilter ||
            suggestionCardFilter === TrackChangeStatus.PENDING
        ) {
            status = TrackChangeStatus.PENDING
        } else if (suggestionCardFilter === TrackChangeStatus.APPROVED) {
            status = TrackChangeStatus.APPROVED
        } else {
            status = TrackChangeStatus.REJECTED
        }

        let trackChange = trackChangesData[`${suggestion?.id}:${status}`]

        if (!trackChange) {
            return null
        }

        return (
            <Card
                cardSuggestion={suggestion}
                trackChanges={trackChange}
                isNotDefaultSuggestionCardFilter={
                    isNotDefaultSuggestionCardFilter
                }
            />
        )
    }
)
